/* @flow */
import React, { Component } from 'react'

import './ExplainerDiagram.css'

import explainerLine from '../../../../images/explainer-line-connector.svg'
import dashedCircleSmall from '../../../../images/dashed-circle-small.svg'
import dashedCircleMedium from '../../../../images/dashed-circle-medium.svg'
import dashedCircleLarge from '../../../../images/dashed-circle-large.svg'
import shieldCheck from '../../../../images/icons/shield-check.svg'

type Props = {
  openContactForm: Function,
}

export default class ExplainerDiagram extends Component<Props> {

  render() {
    return (
      <div className="ExplainerDiagram explainer-diagram">
        <div className="explainer-diagram--container container">
          <div className="explainer-top">
            <div>
              <div onClick={(e) => this.props.openContactForm(e, 'contributor')} className="explainer-box hoverable">
                <h3>Data Providers</h3>
                <p className="small">Monetize your data directly, while maintaining control & privacy</p>
                <div className="secondary-cta">
                  <div><a>MONETIZE DATA <i className="icon icon-arrow-right-thick" /></a></div>
                </div>
              </div>
            </div>
            <div className="explainer-connector">
              <img className="explainer-lines" src={explainerLine}/>
              <div className="explainer-shield-container">
                <img className="explainer-shield" src={shieldCheck}/>
                <img className="explainer-circle-small" src={dashedCircleSmall}/>
                <img className="explainer-circle-medium" src={dashedCircleMedium}/>
                <img className="explainer-circle-large" src={dashedCircleLarge}/>
              </div>
            </div>
            <div>
              <div onClick={(e) => this.props.openContactForm(e, 'consumer')} className="explainer-box hoverable">
                <h3>Data Buyers</h3>
                <p className="small">Access complete and verified data on a global level</p>
                <div className="secondary-cta">
                  <div><a>PURCHASE DATA <i className="icon icon-arrow-right-thick" /></a></div>
                </div>
              </div>
            </div>
          </div>
          <div className="explainer-bottom">
            <div onClick={(e) => this.props.openContactForm(e, 'verifier')} className="explainer-box hoverable">
              <h3>Data Verifiers</h3>
              <p className="small">Rewarded to ensure data is accurate</p>
              <div className="secondary-cta">
                <div><a>VERIFY DATA <i className="icon icon-arrow-right-thick" /></a></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/Page/Home/ExplainerDiagram/ExplainerDiagram.js